import {ADMIN} from 'constants/enum/userRoles'
import {useGetCurrentUserQuery} from 'store/Store'

export function useAuthorization() {
    const {data} = useGetCurrentUserQuery()

    const {isSuperUser} = data || {}
    const hasRole = (requiredRoles) => {
        if (!data) return false

        // If requiredRoles is a string, convert to array
        const roles = Array.isArray(requiredRoles) ? requiredRoles : [requiredRoles]

        // Check if user has at least one of the required roles
        return roles.some((role) => data.roles.includes(role))
    }

    const isAdmin = () => {
        return hasRole(ADMIN)
    }

    const canAccess = (resource, action) => {
        // For more granular permissions beyond roles
        // You can implement permission-based logic here
        // Example: Check if user has permission to perform action on resource

        // Simple example:
        if (isAdmin()) return true

        if (!data || !data.permissions) return false

        return data.permissions.some(
            (permission) => permission.resource === resource && permission.actions.includes(action)
        )
    }

    const isSuper = () => {
        return isSuperUser
    }

    return {hasRole, isAdmin, canAccess, isSuper}
}
